import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconCopy = ({ id, color, width = 44, style, ...restProps }: IProps) => {
  const viewBoxWidth = 44;
  const viewBoxHeight = 50;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M9.943 44.261h-4.6C2.398 44.261 0 41.858 0 38.904V5.357C0 2.404 2.397 0 5.344 0h25.44c2.946 0 5.343 2.404 5.343 5.357v2.975h2.53c2.946 0 5.343 2.403 5.343 5.357v30.954C44 47.597 41.603 50 38.656 50H15.287c-2.947 0-5.344-2.403-5.344-5.357v-.382zM32.28 8.331V5.358a1.5 1.5 0 0 0-1.496-1.5H5.344a1.5 1.5 0 0 0-1.497 1.5v33.547a1.5 1.5 0 0 0 1.497 1.5h4.6V13.689c0-2.954 2.376-5.357 5.298-5.357H32.28zM15.242 12.19c-.8 0-1.451.673-1.451 1.5v30.954a1.5 1.5 0 0 0 1.496 1.5h23.37a1.5 1.5 0 0 0 1.496-1.5V13.689a1.5 1.5 0 0 0-1.497-1.5H15.242z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconCopy;
